import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';

import constants from '../../../_consts';
import {buildOptions, buildOptionsFormData, getEndPoint} from '../../../utils/api-call';
import {makeCall} from '../../../utils/request';
import state from './states';
import * as _ from 'lodash';

Vue.use(VueAxios, axios);

const actions = {
  ACTION_DO_LOGIN: ({commit, state}, user) => {
    return new Promise((resolve, reject) => {
      if (state.showCaptcha) {
        if (!state.allowLogin) {
          Vue.prototype.$toastr('info', 'Cannot login', '');
          resolve(null);
          return;
        }
      }
      let apiStr = getEndPoint().clients.doLogin;
      Vue.axios.post(apiStr, user).then((response) => {
        if (response.data.message !== null) {
          if (response.data.noOfFailAttempts > 5) {
            state.allowLogin = state.showCaptcha;
            state.showCaptcha = true;
          }
          state.siteKey = constants.siteKey;
          if (response.data.message === constants.messageErrors.userDeleted) {
            Vue.prototype.$toastr('error', 'Your account is deleted. Please contact ADURO.', '');
          } else {
            Vue.prototype.$toastr('error', response.data.message, '');
          }
        } else {
          if (response.data.isFirstLogin) {
            Vue.prototype.$toastr('info', 'Login at first time, please change password!', '');
            localStorage.setItem('isFirstLogin', true);
            state.resetPassToken = response.data.resetPassToken;
          } else {
            if (response.data.mfaType === null) {
              localStorage.removeItem('isFirstLogin');
              commit('MUTATION_DO_LOGIN', response);
            }
          }
          state.allowLogin = true;
        }
        resolve(response);
      }).catch(function (response) {
        Vue.prototype.$toastr('error', (response.data && response.data.message) || 'Cannot log in!', '');
        state.loginError = true;
        state.allowLogin = false;
      });
    })
  },
  ACTION_DO_LOGOUT: ({commit}) => {
    commit('MUTATION_DO_LOGOUT');
    Vue.prototype.$toastr('info', 'Logout', '');
  },
  ACTION_SELECT_CLIENT: ({commit}, itemSelected) => {
    commit('MUTATION_SET_SELECT_CLIENT', itemSelected);
  },
  ACTION_GET_CLIENT: async ({commit}, clientId) => {
    let apiUrl = getEndPoint().clients.getClient;
    let response = await axios.get(apiUrl, {
      params: {
        clientId: clientId
      }
    });
    return response;
  },
  ACTION_GET_CLIENTS: ({commit}) => {
    let apiStr = getEndPoint().clients.getClients;
    Vue.axios.get(apiStr, {
      params: {
        userId: localStorage.getItem(constants.LOCAL_STORE.userId)
      }
    }).then((response) => {
      if (response.data.message !== null) {
        commit('MUTATION_SET_CLIENTS', []);
      } else {
        commit('MUTATION_SET_CLIENTS', response.data.clients);
        // save client recent activity
        let recentClients = _.cloneDeep(response.data.clients);
        recentClients.sort(function (a, b) {
          return b.lastUpdatedAt - a.lastUpdatedAt || 0;
        });
        commit('MUTATION_SET_RECENT_CLIENTS', recentClients);
      }
    }).catch(function (response) {
      console.log('Error:', response);
    });
  },
  ACTION_SYNCS_CLIENTS_PROGRAMS: ({commit}) => {
    let apiStr = getEndPoint().clients.syncClientsAndPrograms;
    return new Promise((resolve, reject) => {
      makeCall(apiStr, buildOptions('POST')).then(response => {
        resolve(response);
      }, error => {
        reject(error);
      });
    });
  },
  ACTION_SYNCS_ORDERS: ({commit}) => {
    let apiStr = getEndPoint().clients.syncBiometricOrders;
    return new Promise((resolve, reject) => {
      makeCall(apiStr, buildOptions('POST')).then(response => {
        resolve(response);
      }, error => {
        reject(error);
      });
    });
  },
  ACTION_SYNCS_USER_STATUS: ({commit}) => {
    let apiStr = getEndPoint().clients.syncUsersStatus;
    return new Promise((resolve, reject) => {
      makeCall(apiStr, buildOptions('POST')).then(response => {
        resolve(response);
      }, error => {
        reject(error);
      });
    });
  },
  ACTION_SYNCS_EVENTS: ({commit}) => {
    let apiStr = getEndPoint().clients.syncEvents;
    return new Promise((resolve, reject) => {
      makeCall(apiStr, buildOptions('POST')).then(response => {
        resolve(response);
      }, error => {
        reject(error);
      });
    });
  },
  ACTION_SYNCS_STAFFS: ({commit}) => {
    let apiStr = getEndPoint().clients.syncStaffs;
    return new Promise((resolve, reject) => {
      makeCall(apiStr, buildOptions('POST')).then(response => {
        resolve(response);
      }, error => {
        reject(error);
      });
    });
  },
  ACTION_SEARCH_CLIENTS: ({commit}, keyword) => {
    commit('MUTATION_SET_KEYWORD_SEARCH_CLIENTS', keyword);
  },
  ACTION_RESET_SEARCH_CLIENTS: ({commit}) => {
    commit('MUTATION_RESET_SEARCH_CLIENTS');
  },
  ACTION_RESET_PASSWORD: async ({commit}, email) => {
    commit('MUTATION_IS_RESET_PASSWORD_SUCCESS', false);
    commit('MUTATION_IS_SUBMITTED', true);
    let apiUrl = getEndPoint().clients.requestResetPassword;
    await Vue.axios.get(apiUrl, {
      params: {
        email: email
      }
    }).then((response) => {
      if (response.data.message !== null) {
        commit('MUTATION_SET_ERROR', {isError: true, errorMessage: response.data.message});
        Vue.prototype.$toastr('error', response.data.message, '');
        commit('MUTATION_IS_RESET_PASSWORD_SUCCESS', false);
      } else {
        commit('MUTATION_SET_ERROR', {isError: false, errorMessage: ''});
        commit('MUTATION_IS_RESET_PASSWORD_SUCCESS', true);
        Vue.prototype.$toastr('success', 'A reset password email has been sent to ' + email, '');
      }
      commit('MUTATION_IS_SUBMITTED', false);
    }).catch(function (response) {
      console.log(response);
      Vue.prototype.$toastr('error', response, '');
    });
  },
  ACTION_CHECK_TOKEN: async ({commit}, token) => {
    let apiUrl = getEndPoint().clients.checkToken;
    await Vue.axios.get(apiUrl, {
      params: {
        token: token
      }
    }).then((response) => {
      if (response.data.message !== null) {
        commit('MUTATION_SET_TOKEN_VALID', false);
        Vue.prototype.$toastr('error', response.data.message, '');
      } else {
        commit('MUTATION_SET_TOKEN_VALID', true);
      }
    }).catch(function (response) {
      commit('MUTATION_SET_TOKEN_VALID', false);
      console.log(response);
      Vue.prototype.$toastr('error', response, '');
    });
  },
  ACTION_UPDATE_PASSWORD: async ({commit}, params) => {
    let apiUrl = getEndPoint().clients.internalPasswordReset;
    await Vue.axios.post(apiUrl, {
      newPassword: params.newPassword,
      token: params.token,
      isForceResetPassword: params.isForceResetPassword,
      userId: params.userId
    }).then((response) => {
      if (response.data.message !== null) {
        Vue.prototype.$toastr('error', response.data.message, '');
        commit('MUTATION_SET_TOKEN_VALID', false);
      } else {
        Vue.prototype.$toastr('success', 'Change password successful', '');
        localStorage.removeItem(constants.LOCAL_STORE.isForceResetPassword);
        commit('MUTATION_SET_TOKEN_VALID', true);
        commit('MUTATION_SET_LOGIN_EMAIL', response.data.userProfile.email);
      }
    }).catch(function (response) {
      console.log(response);
      Vue.prototype.$toastr('error', response, '');
    });
  },
  ACTION_CHANGE_PASSWORD: async ({commit}, obj) => {
    let apiUrl = getEndPoint().clients.internalPasswordChange;
    let body = {
      newPassword: obj.newPassword,
      oldPassword: obj.oldPassword,
      userId: localStorage.getItem(constants.LOCAL_STORE.userId)
    };

    return new Promise((resolve, reject) => {
      makeCall(apiUrl, buildOptions('POST', body)).then(response => {
        resolve(response);
      }, error => {
        reject(error);
      });
    });
  },
  ACTION_UPLOAD_FILE: async ({commit}, data) => {
    let apiUrl = getEndPoint().clients.importUser;
    let formData = new FormData();
    formData.append('file', data);
    await Vue.axios.post(apiUrl, formData).then((response) => {
      Vue.prototype.$toastr('success', response.data, '');
    })
  },
  ACTION_ALLOW_LOGIN: ({commit, state}, obj) => {
    console.log('obj:', obj);
    commit('MUTATION_ALLOW_LOGIN', obj.isAllowed);
    if (!obj.isAllowed) {
      commit('MUTATION_SET_ERROR', obj.errObj);
    }
  },
  ACTION_GET_LIST_AM: async ({commit}) => {
    let apiUrl = getEndPoint().clients.getAllAM;
    await Vue.axios.get(apiUrl).then((response) => {
      if (response.data.userProfiles !== null && response.data.userProfiles.length > 0) {
        response.data.userProfiles.forEach((element) => {
          element.name = element.firstName + ' ' + element.lastName;
        });
        commit('MUTATION_SET_LIST_AM', response.data.userProfiles)
      } else {
        commit('MUTATION_SET_LIST_AM', [])
      }
    }).catch(function (response) {
      console.log(response);
    })
  },
  ACTION_UPDATE_CLIENT: ({commit}, client) => {
    let apiUrl = getEndPoint().clients.updateClient;
    return new Promise((resolve, reject) => {
      Vue.axios.post(apiUrl, client).then((response) => {
        Vue.prototype.$toastr('info', 'Update success', '');
        resolve(response)
      }).catch(function (error) {
        console.log(error);
        reject(error);
      })
    })
  },
  ACTION_UPDATE_CLIENT_NAME: ({commit}, clientName) => {
    state.clientName = clientName;
  },
  ACTION_VERIFY_RECAPTCHA: ({commit}, code) => {
    let apiUrl = getEndPoint().clients.verifyRecaptcha;
    Vue.axios.post(apiUrl, code).then((response) => {
      let errObj;
      if (response.data) {
        commit('MUTATION_ALLOW_LOGIN', response.data);
        errObj = {
          isError: false,
          errorMessage: ''
        };
      } else {
        errObj = {
          isError: true,
          errorMessage: 'Captcha is invalid!'
        };
      }
      commit('MUTATION_SET_ERROR', errObj);
    }).catch(function (response) {
      console.log(response);
    });
  },
  ACTION_UPDATE_MESSAGE: async ({commit}, obj) => {
    let apiUrl = getEndPoint().clients.updateMessage;
    await Vue.axios.post(apiUrl, obj).then((response) => {
      if (response.data.message) {
        Vue.prototype.$toastr('error', response.data.message, '');
      } else {
        Vue.prototype.$toastr('success', 'Saved message successfully!', '');
      }
    }).catch(function (response) {
      console.log(response);
    });
  },
  UPDATE_ADD_ON: async ({commit}, obj) => {
    let apiUrl = getEndPoint().clients.updateAddOn;
    return new Promise((resolve, reject) => {
      makeCall(apiUrl, buildOptions('POST', obj)).then(response => {
        if (response.message) {
          Vue.prototype.$toastr('error', response.message, '');
        } else {
          Vue.prototype.$toastr('success', 'Update add-on success!', '');
          commit('MUTATION_UPDATE_ADDON_CLIENT', {clientId: obj.clientId, addOns: response.addOns});
        }
        resolve(response);
      }, error => {
        reject(error);
      });
    });
  },
  ACTION_GET_MESSAGE_MODAL: ({state, commit}) => {
    let apiUrl = getEndPoint().clients.getMessages;
    let clientId = localStorage.getItem(constants.LOCAL_STORE.clientId);
    Vue.axios.get(apiUrl, {
      params: {
        clientId: clientId
      }
    }).then((response) => {
      state.submissionMessage = response.data.data.submissionMessage;
      state.changeOrderMessage = response.data.data.changeOrderMessage;
    });
  },
  ACTION_CHANGE_NOTIFICATION: ({state}, isChecked) => {
    let apiUrl = getEndPoint().clients.changeNotification;
    let body = {
      isChecked: isChecked,
      userId: localStorage.getItem(constants.LOCAL_STORE.userId)
    };
    Vue.axios.post(apiUrl, body).then((response) => {
      // Vue.prototype.$toastr('success', (isChecked ? 'Enable' : 'Disable') + ' sending email.', '');
      state.isCheckedNotification = isChecked;
    }).catch(function (response) {
      console.log(response);
    });
  },
  ACTION_UPDATE_SECONDARY_AM: ({state, commit}, obj) => {
    let apiUrl = getEndPoint().clients.updateSecondaryAM;
    let body = {
      clientId: obj.clientId,
      userId: obj.user.id
    };
    Vue.axios.post(apiUrl, body).then((response) => {
      commit('MUTATION_UPDATE_SECONDARY_AM', obj);
      Vue.prototype.$toastr('info', 'Update secondary successfully', '');
    }).catch(function (response) {
      console.log(response);
    });
  },
  ACTION_UPDATE_VALIDATORS_TO_CLIENT: ({state}, obj) => {
    let apiUrl = getEndPoint().clients.updateValidatorsToClient;
    return new Promise((resolve, reject) => {
      makeCall(apiUrl, buildOptions('POST', obj)).then(response => {
        resolve(response);
      }, error => {
        reject(error);
      });
    });
  },
  ACTION_UPDATE_SUB_CLIENT: ({state, commit}, obj) => {
    let apiUrl = obj.isReseller !== undefined ? getEndPoint().clients.updateReseller : getEndPoint().clients.updateClientManager;
    Vue.axios.post(apiUrl, obj).then((response) => {
      if (obj.isReseller !== undefined) {
        commit('MUTATION_UPDATE_RESELLER', obj);
        Vue.prototype.$toastr('info', 'Update successfully', '');
      } else {
        // commit('MUTATION_UPDATE_RESELLER', obj);
        Vue.prototype.$toastr('info', 'Update successfully', '');
      }
    }).catch(function (response) {
      console.log(response);
    });
  },
  ACTION_ADD_CLIENT: async ({commit}, obj) => {
    let apiUrl = getEndPoint().clients.addClient;
    return new Promise((resolve, reject) => {
      makeCall(apiUrl, buildOptions('POST', obj)).then(response => {
        resolve(response);
        commit('MUTATION_UPDATE_CLIENT_LIST', response.data);
      }, error => {
        reject(error);
      });
    });
  },
  ACTION_GET_ALL_USERS: ({state, commit}) => {
    let apiUrl = getEndPoint().clients.getAllUsers;
    state.isLoading = true;
    Vue.axios.get(apiUrl, {
      params: {
        userId: localStorage.getItem(constants.LOCAL_STORE.userId)
      }
    }).then((response) => {
      state.isLoading = false;
      commit('MUTATION_SET_ALL_USER', response.data.userProfiles || []);
    }).catch(function (response) {
      console.log(response);
    });
  },
  ACTION_CREATE_USER: ({state, commit}, obj) => {
    obj.email = obj.email.toLowerCase();
    let apiUrl = getEndPoint().clients.createUser;
    Vue.axios.post(apiUrl, obj).then((response) => {
      if (response && response.data && response.data.message === null) {
        commit('MUTATION_CREATE_USER', response.data.userProfile);
        Vue.prototype.$toastr('info', 'Create successfully', '');
      } else {
        if (response.data.message === constants.messageErrors.emailIsDuplicated) {
          Vue.prototype.$toastr('error', 'Email is duplicated!', '');
        }
      }
    }).catch(function (response) {
      Vue.prototype.$toastr('error', 'Create user unsuccessfully', '');
    });
  },
  ACTION_EDIT_USER: ({state, commit}, obj) => {
    let apiUrl = getEndPoint().clients.updateUser;
    Vue.axios.post(apiUrl, obj).then((response) => {
      commit('MUTATION_UPDATE_USER', response.data.userProfile);
      Vue.prototype.$toastr('info', 'Update successfully', '');
    }).catch(function (response) {
      Vue.prototype.$toastr('error', 'Update user unsuccessfully', '');
    });
  },
  ACTION_UPDATE_READ_ONLY: ({state, commit}, obj) => {
    let apiUrl = getEndPoint().clients.updateReadOnly;
    Vue.axios.post(apiUrl, obj).then((response) => {
      if (response && response.data) {
        Vue.prototype.$toastr('info', 'Update successfully', '');
      }
    }).catch(function (response) {
      console.log(response);
    });
  },
  ACTION_ACTION_DELETE_USER: ({state, commit}, obj) => {
    let apiUrl = getEndPoint().clients.deleteUser;
    return new Promise((resolve, reject) => {
      makeCall(apiUrl, buildOptions('DELETE', obj)).then(response => {
        if (response && response.userProfile) {
          commit('MUTATION_REMOVE_USER_IN_LIST', response.userProfile)
        }
        resolve(response);
      }, error => {
        reject(error);
      });
    });
  },
  ACTION_FORCE_RESET_PASSWORD: ({commit}, userId) => {
    let apiUrl = getEndPoint().staff.forceResetPassword;
    let body = {userId: userId};
    Vue.axios.post(apiUrl, body).then(response => {
      Vue.prototype.$toastr('info', 'Email successful sent', '');
    }).catch(function (response) {
      Vue.prototype.$toastr('error', 'Email unsuccessful sent');
    });
  },
  ACTION_SAVE_CLIENT_NAME: ({commit}, obj) => {
    // obj = {
    //   clientId: clientId,
    //   clientName: clientName
    // }
    let apiUrl = getEndPoint().clients.updateClientName;
    let body = {id: obj.clientId, clientName: obj.clientName};
    Vue.axios.post(apiUrl, body).then(response => {
      if (response.data.message) {
        Vue.prototype.$toastr('error', response.data.message ? response.data.message : 'Save client name unsuccessful', '');
      } else {
        Vue.prototype.$toastr('info', 'Save client name successful', '');
      }
    }).catch(() => {});
  },
  ACTION_GET_ALL_VALIDATORS: ({state}) => {
    let apiUrl = getEndPoint().clients.getAllValidators;
    return new Promise((resolve, reject) => {
      makeCall(apiUrl, buildOptions('GET', {})).then(response => {
        resolve(response);
        state.validators = response.validators;
      }, error => {
        reject(error);
      });
    });
  },
  ACTION_GET_VALIDATORS_BY_CLIENT_ID: ({state}, clientId) => {
    let apiUrl = getEndPoint().clients.getValidatorsByClientId + '/' + clientId;
    return new Promise((resolve, reject) => {
      makeCall(apiUrl, buildOptions('GET')).then(response => {
        resolve(response);
      }, error => {
        reject(error);
      });
    });
  },
  ACTION_CREATE_VALIDATOR: ({state}, obj) => {
    let apiUrl = getEndPoint().clients.addValidator;
    let body = {
      name: obj.name,
      field: obj.field
    };
    return new Promise((resolve, reject) => {
      makeCall(apiUrl, buildOptions('POST', body)).then(response => {
        resolve(response);
        Vue.prototype.$toastr('info', 'Successfully created', '');
      }, error => {
        reject(error);
        Vue.prototype.$toastr('warning', 'Unsuccessfully created', '');
      });
    });
  },
  ACTION_UPDATE_VALIDATOR: ({state}, obj) => {
    let apiUrl = getEndPoint().clients.addValidator;
    let body = {
      id: obj.id,
      name: obj.name,
      field: obj.field
    };
    return new Promise((resolve, reject) => {
      makeCall(apiUrl, buildOptions('POST', body)).then(response => {
        resolve(response);
        Vue.prototype.$toastr('info', 'Successfully updated', '');
      }, error => {
        reject(error);
        Vue.prototype.$toastr('warning', 'Unsuccessfully updated', '');
      });
    });
  },
  ACTION_DELETE_VALIDATOR: ({state}, id) => {
    let apiUrl = getEndPoint().clients.deleteValidator;
    return new Promise((resolve, reject) => {
      makeCall(apiUrl, buildOptions('GET', {params: {validatorId: id}})).then(response => {
        resolve(response);
        Vue.prototype.$toastr('info', 'Successfully deleted', '');
      }, error => {
        reject(error);
        Vue.prototype.$toastr('warning', 'Unsuccessfully deleted', '');
      });
    });
  },
  ACTION_GET_CLIENT_SCHEDULER_CONFIG: ({state}, clientId) => {
    let apiUrl = getEndPoint().clients.getSchedulerConfiguration;
    return new Promise((resolve, reject) => {
      makeCall(apiUrl, buildOptions('GET', {params: {clientId: clientId}})).then(response => {
        resolve(response);
      }, error => {
        reject(error);
      });
    });
  },
  ACTION_GET_EMAIL_TAGS: ({state}) => {
    let apiUrl = getEndPoint().clients.getAvailableEmailTags;
    return new Promise((resolve, reject) => {
      makeCall(apiUrl, buildOptions('GET')).then(response => {
        resolve(response);
      }, error => {
        reject(error);
      });
    });
  },
  ACTION_SAVE_CONFIGURATIONS: ({state}, configs) => {
    let apiUrl = getEndPoint().clients.saveConfigurations;

    return new Promise((resolve, reject) => {
      makeCall(apiUrl, buildOptions('POST', configs), 100000).then(response => {
        resolve(response);
      }, error => {
        Vue.prototype.$toastr('error', error, '');
        reject(error);
      });
    });
  },
  ACTION_SAVE_EMAIL_TEMPLATES: ({state}, templates) => {
    let apiUrl = getEndPoint().settings.saveEmailTemplates;
    let body = {templates: templates};
    return new Promise((resolve, reject) => {
      makeCall(apiUrl, buildOptions('POST', body)).then(response => {
        resolve(response);
      }, error => {
        reject(error);
      });
    });
  },
  ACTION_UPLOAD_LOGO: ({state}, obj) => {
    let apiUrl = getEndPoint().clients.uploadAvatar;
    let body = {
      clientId: obj.clientId,
      imageFile: obj.imageFile
    };

    let formData = new FormData();
    formData.append('content', obj.imageFile);
    formData.append('clientId', obj.clientId);

    console.log('body:', body, 'formData:', formData);
    return new Promise((resolve, reject) => {
      makeCall(apiUrl, buildOptionsFormData('POST', formData)).then(response => {
        resolve(response);
      }, error => {
        reject(error);
      });
    });
  },
  ACTION_GET_CLIENT_EVENT_SCHEDULER_STATUS: ({state}, clientId) => {
    let apiUrl = getEndPoint().clients.getClientEventSchedulerStatus;
    return new Promise((resolve, reject) => {
      makeCall(apiUrl, buildOptions('GET', {params: {clientId: clientId}})).then(response => {
        resolve(response);
      }, error => {
        reject(error);
      });
    });
  },
  ACTION_UPDATE_CLIENT_EVENT_SCHEDULER_STATUS: ({state}, obj) => {
    let apiUrl = getEndPoint().clients.updateClientEventSchedulerStatus;
    return new Promise((resolve, reject) => {
      makeCall(apiUrl, buildOptions('POST', obj)).then(response => {
        resolve(response);
      }, error => {
        reject(error);
      });
    });
  },
  ACTION_DELETE_CLIENT: ({ state }, body) => {
    let apiUrl = getEndPoint().clients.deleteClient;
    return new Promise((resolve, reject) => {
      makeCall(apiUrl, buildOptions('POST', body)).then(response => {
        resolve(response);
      }, error => {
        reject(error);
      })
    })
  },
  ACTION_GET_LIST_EM: ({ state }, body) => {
    let apiUrl = getEndPoint().clients.getListEM;
    return new Promise((resolve, reject) => {
      makeCall(apiUrl, buildOptions('GET', body)).then(response => {
        resolve(response);
      }, error => {
        reject(error);
      })
    })
  },
  ACTION_GET_VALIDATORS_BY_EVENT_ID: ({state}, eventId) => {
    let apiUrl = getEndPoint().clients.getValidatorsByEventId + '/' + eventId;
    return new Promise((resolve, reject) => {
      makeCall(apiUrl, buildOptions('GET', {params: {eventId: eventId}})).then(response => {
        resolve(response);
      }, error => {
        reject(error);
      })
    })
  },
  ACTION_SYNC_SHIFTBOARD_BASE_DATA: ({state}) => {
    return new Promise((resolve, reject) => {
      makeCall(getEndPoint().clients.syncBasicShiftBoard, buildOptions('POST'))
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    })
  },
  ACTION_GET_PROGRAM_CLIENT: ({state, commit}, clientId) => {
    let apiUrl = getEndPoint().clients.getProgramClient;
    return new Promise((resolve, reject) => {
      makeCall(apiUrl, buildOptions('GET', {params: { clientId }})).then(response => {
        resolve(response);
      }, error => {
        reject(error);
      });
    });
  },
  ACTION_GET_CLIENTS_PAGING: ({commit}, params) => {
    return new Promise((resolve, reject) => {
      makeCall(getEndPoint().clients.getClientsPaging, buildOptions('GET', {params: {...params, userId: localStorage.getItem(constants.LOCAL_STORE.userId)}})).then(response => {
        resolve(response);
      }, error => {
        reject(error);
      });
    });
  }
};

export default actions



// WEBPACK FOOTER //
// ./src/store/modules/clients/actions.js